<template>
    <b-sidebar
    id="sidebar-agreement-details"
    ref="sidebarAgreementDetail"
    title="Sidebar"
    aria-labelledby="sidebar-title"
    bg-variant='white'
    :width="width=='large'? '500px' : ''"
    :visible="visible"
    no-header
    right
    shadow
    >
      <template>
        <div class="sidebar-header px-4 py-3">
          <h4 id="sidebar-title" class="mt-2">{{ title }}</h4>
        </div>
        <slot></slot>
      </template>
    </b-sidebar>
</template>

<script>
export default {
  name: 'SideBar',
  props: {
      title: String,
      width: String, // 'default' or 'large'
      visible: Boolean,
  }
}
</script>

<style scoped>
.sidebar-header{
   background-color: #F8F8F8;
 }
</style>
